import { UseMutateAsyncFunction, useMutation } from 'react-query';

import { getAPIErrorMessage } from '../../../utils/ApiErrorUtils';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

function useVerifyPhoneNumberOTP(): {
  verifyPhoneNumberOTPAPI: UseMutateAsyncFunction<
    any,
    unknown,
    {
      phoneNumber: string;
      countryCode: string;
      clientId: string;
      otpValue: string;
      acceptedTandC: boolean | null;
    },
    unknown
  >;
  error: string;
  status;
} {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const verifyPhoneNumberOTP = (params) => {
    const { phoneNumber, countryCode, clientId, otpValue, acceptedTandC } =
      params;

    return ibUserAccountsAPIService.loginOtpVerify({
      phone_number: phoneNumber,
      country_code: countryCode,
      client_id: clientId,
      otp_value: otpValue,
      accepted_tnc: acceptedTandC
    });
  };

  const { mutateAsync, error, status } = useMutation(verifyPhoneNumberOTP);

  const verifyPhoneNumberOTPAPI = mutateAsync;

  return {
    verifyPhoneNumberOTPAPI,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
}

export { useVerifyPhoneNumberOTP };
